module.exports = __webpack_public_path__ + "static/media/logout.f504e6f6.svg";